import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"check"}/>
}
